/** 既定書式: 年月日 + 時分 + タイムゾーン名（例: 2026年6月22日 17:57 JST） */
const DEFAULT_OPTIONS: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  timeZoneName: 'short'
};

/**
 * Date をブラウザのローカルタイムゾーン（= PC の設定時間。日本なら JST）で
 * 表示用に整形する。`options` で書式を上書きできる。
 */
export function formatDateTimeToLocal(date: Date, locale?: string, options: Intl.DateTimeFormatOptions = DEFAULT_OPTIONS): string {
  try {
    return new Intl.DateTimeFormat(locale, options).format(date);
  } catch {
    return date.toLocaleString();
  }
}